<template>
  <div class="delivery">
    <NavBar title="配送管理" :default-bg="false"/>
    <div class="top">
      <div class="choose-date">
        <div class="date" @click="showDate = true">
          {{ date }}
        </div>
        <div class="time-span" @click="showTime = true">
          <span>{{ food }}</span>
          <img src="../../assets/images/triangle_down.png" alt="">
        </div>
      </div>
      <div class="status">
        <div v-if="status===0" style="color: #126AFC">未开始</div>
        <div v-if="status===1" class="running">
          订餐中
          <van-count-down :time="endTime">
            <template #default="timeData">
                <span class="time">
                  (
                    {{ timeData.hours < 10 ? '0' + timeData.hours : timeData.hours }}:
                    {{ timeData.minutes < 10 ? '0' + timeData.minutes : timeData.minutes }}:
                    {{ timeData.seconds < 10 ? '0' + timeData.seconds : timeData.seconds }}截止
                  )
                </span>
            </template>
          </van-count-down>
        </div>
        <div v-if="status===2" style="color: #126AFC">备餐中</div>
        <div v-if="status===3" style="color: #2DAA45">送餐中</div>
        <div v-if="status===4" style="color: red">配送完成</div>
        <div v-if="status===5" style="color: gray">无可配送订单</div>
      </div>
    </div>
    <!--列表-->
    <div class="list-container">
      <div class="nav-box">
        <div class="nav">
          <nav>
            <div class="nav-item" :class="address === 0 ? 'active' : ''"
                 @click="checkAddress(0,0,false)">
              制餐统计
            </div>
            <div class="nav-item" v-for="(item,index) in addressArr" :key="index"
                 :class="address === index+1 ? 'active' : ''"
                 @click="checkAddress(index+1,item.roomId)">
              <span>{{ item.roomName }}</span>
            </div>
          </nav>
        </div>
      </div>
      <div class="content">
        <div v-if="address === 0" class="dining">
          <div class="tab">
            <div class="tab-item" :class="tabActive===0?'tab-active':''" @click="checkTab(0)">按餐品统计</div>
            <div class="tab-item" :class="tabActive===1?'tab-active':''" @click="checkTab(1)">按地址统计</div>
          </div>
          <div class="statistics-box">
            <div class="total">
              <div class="total-item1">
                <span>医院订餐</span>
                <span>用户订餐</span>
                <span>总计</span>
              </div>
              <div class="total-item1">
                <span>{{ hospitalOrderNum }}</span>
                <span>{{ userOrderNum }}</span>
                <span>{{ totalOrderNum }}</span>
              </div>
              <div class="total-item2">共 {{ totalAddressNum }} 个地址</div>
            </div>
            <div v-if="tabActive===0" class="mealType-total">
              <div class="list">
                <div class="list-wrap" v-if="mealTotal.hospitalOrders">
                  <div class="list-title">医院订餐</div>
                  <div class="table">
                    <div class="tTitle">
                      <span>餐品名称</span>
                      <span>份数</span>
                    </div>
                    <div class="tBody">
                      <div class="tItem" v-for="(type,index) in mealTotal.hospitalOrders" :key="index">
                        <span>{{ type.goodsName }}</span>
                        <span>{{ type.orderNum === 0 ? '' : type.orderNum }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-wrap" v-if="mealTotal.systemOrders">
                  <div class="list-title">用户订餐</div>
                  <div class="table">
                    <div class="tTitle">
                      <span>餐品名称</span>
                      <span>份数</span>
                    </div>
                    <div class="tBody">
                      <div class="tItem" v-for="(type,index) in mealTotal.systemOrders" :key="index">
                        <span>{{ type.goodsName }}</span>
                        <span>{{ type.orderNum === 0 ? '' : type.orderNum }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="tabActive===1" class="addressType-total">
              <div class="addressType-item" v-for="(item,index) in addressTotal" :key="index">
                <div class="item-name">{{ item.roomName }}</div>
                <table>
                  <thead>
                  <tr>
                    <th>医院订餐</th>
                    <th>用户订餐</th>
                    <th>总计</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>{{ item.hospitalOrderNum }}</td>
                    <td>{{ item.systemOrderNum }}</td>
                    <td>{{ item.total }}</td>
                  </tr>
                  </tbody>
                </table>
                <table v-if="item.hospitalOrders.length">
                  <thead>
                  <tr>
                    <th>餐品名称（医院订餐）</th>
                    <th>份数</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(i,index2) in item.hospitalOrders" :key="index+index2">
                    <td>{{ i.goodsName }}</td>
                    <td>{{ i.orderNum }}</td>
                  </tr>
                  </tbody>
                </table>
                <table v-if="item.systemOrders.length">
                  <thead>
                  <tr>
                    <th>餐品名称（用户订餐）</th>
                    <th>份数</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(i,index2) in item.systemOrders" :key="index+index2">
                    <td>{{ i.goodsName }}</td>
                    <td>{{ i.orderNum }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="noMore">没有更多了...</div>
            <button class="allSend themeColor" @click="sendOut(mealId)" v-if="status===2">全部送出</button>
          </div>
        </div>
        <!--科室-->
        <div v-else class="division">
          <div class="division-name">{{ singleAddress.roomName }}</div>
          <div class="date">{{ date }} {{ food }}</div>
          <div class="grid-container">
            <div class="catering">
              <table>
                <thead>
                <tr>
                  <th>床号别</th>
                  <th>病历号</th>
                  <th>姓名</th>
                  <th>餐别</th>
                  <th>质地</th>
                  <th>成分别</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in singleAddress.hospitalOrdersUserMsg" :key="index" @click="showRecordDetail(item.orderItemId)" :class="item.returnType!=null && item.returnType==4 ? 'tr-red':''">
                  <td>{{ item.bedName }}</td>
                  <td>{{ item.userNo }}</td>
                  <td>{{ item.userName }}</td>
                  <td>{{ item.goodsNo }}</td>
                  <td>{{ item.quality }}</td>
                  <td>{{ item.attr }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="meal">
              <table>
                <thead>
                <tr>
                  <th>床号别</th>
                  <th>病历号</th>
                  <th>姓名</th>
                  <th>餐品</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in singleAddress.systemOrdersUserMsg" :key="index" @click="showRecordDetail(item.orderItemId)" :class="item.returnType!=null && item.returnType==4 ? 'tr-red':''">
                  <td>{{ item.bedName }}</td>
                  <td>{{ item.userNo }}</td>
                  <td>{{ item.userName }}</td>
                  <td>{{ item.goodsName }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="catering-total">
              <div class="catering-title">餐别统计</div>
              <table>
                <thead>
                <tr>
                  <th>医院订餐</th>
                  <th>用户订餐</th>
                  <th>总计</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{ singleAddress.hospitalOrderNum }}</td>
                  <td>{{ singleAddress.systemOrderNum }}</td>
                  <td>{{ singleAddress.total }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="hospitalMeal">
              <table>
                <thead>
                <tr>
                  <th>餐品名称（医院订餐）</th>
                  <th>份数</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in singleAddress.hospitalOrders" :key="index">
                  <td>{{ item.goodsName }}</td>
                  <td>{{ item.orderNum }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="userMeal">
              <table>
                <thead>
                <tr>
                  <th>餐品名称（用户订餐）</th>
                  <th>份数</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in singleAddress.systemOrders" :key="index">
                  <td>{{ item.goodsName }}</td>
                  <td>{{ item.orderNum }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="noMore">没有更多了...</div>
          <div class="btnGroup">
            <button class="themeColor" @click="sendOut(mealId,roomId)" v-if="status===2">送出</button>
            <button class="themeColor" @click="openSigning" v-if="status===3">签收码</button>
          </div>
        </div>
      </div>
    </div>

    <!--日期弹框-->
    <van-calendar v-model="showDate" :min-date="minDate" :max-date="maxDate" row-height="32" style="height: 50%"
                  :show-title="false" :show-mark="false" color="#126AFC" @confirm="onConfirm"/>
    <!--时段选择弹框-->
    <van-popup position="bottom" round v-model="showTime">
      <van-picker
          title="请选择"
          show-toolbar
          :columns="columns"
          @confirm="onConfirmTime"
          @cancel="onCancelTime"
      />
    </van-popup>
    <!--签收码弹框-->
    <van-popup position="center" round v-model="showSigning" :close-on-click-overlay="false">
      <div class="signing">
        <div class="tips">请医护人员使用“微信扫码”进行签收</div>
        <div class="qrCodeBox">
          <img :src="signQrcode" alt="">
        </div>
        <div class="close" @click="closeSign">关闭</div>
      </div>
    </van-popup>
    <!--签收成功弹框-->
    <van-popup position="center" round v-model="signSuccess" :close-on-click-overlay="false">
      <div class="signSuccess">
        <div class="success">
          <img src="../../assets/images/completed.png" alt="">
        </div>
        <div class="close" @click="signSuccess = false">关闭</div>
      </div>
    </van-popup>
    <!--单条记录详情-->
    <van-popup v-model="recordDetail" round>
      <div class="recordDetail">
        <div class="title">
          <span>{{ singleRecord.roomName }}</span>
          <span>{{ singleRecord.date }}  {{ singleRecord.mealName }}</span>
        </div>
        <div class="content">
          <div class="item">床号：&nbsp;&nbsp;{{ singleRecord.bedName }}</div>
          <div class="item">姓名：&nbsp;&nbsp;{{ singleRecord.userName }}（{{ singleRecord.userNo }}）</div>
          <div class="meal">
            <span>餐品：&nbsp;&nbsp;</span>
            <span>{{ singleRecord.goodsName }}</span>
          </div>
          <div class="remark">
            <div v-if="singleRecord.orderFrom===2">
              <span>{{ singleRecord.catering }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span>{{ singleRecord.quality }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="singleRecord.attrList.length !==0">{{ singleRecord.attrList[0].attr }}</span>
            </div>
            <div v-if="singleRecord.orderFrom === 0">
              <span v-for="(item,index) in singleRecord.attrList">
                {{ item.groupName + "：" + item.attr }}&nbsp;&nbsp;
              </span>
            </div>
            <div v-if="singleRecord.orderFrom===2">
              <span v-if="singleRecord.cateringName">{{ singleRecord.cateringName }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="singleRecord.cateringName">{{ singleRecord.qualityName }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="singleRecord.attrName">{{ singleRecord.attrName }}</span>
            </div>
          </div>
          <div class="close" @click="recordDetail=false">
            <button>关闭</button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 信息弹框 -->
    <van-popup position="center" round v-model="dischargeInformation" :closeable="true"  :close-on-click-overlay="false">
      <div class="discharge-information">
        <div class="discharge-list">
          <table>
            <tr v-for="(item,index) in leaveHospitalUsers" :key="index">
              <td>{{ item.bedName }}</td>
              <td>{{ item.userNo }}</td>
              <td>{{ item.name }}</td>
              <td>已出院</td>
            </tr>
          </table>
        </div>
        <div class="sub-btn" @click="dischargeInformation = false">确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import NavBar from "../../components/NavBar";
import {Dialog, Toast} from "vant";

export default {
  name: "deliveryManage",
  components: {
    NavBar
  },
  data() {
    return {
      date: '',
      showDate: false,//显示日期弹框
      showTime: false,//显示食物弹框
      showSigning: false,//显示签收码
      signSuccess: false,//显示签收成功
      minDate: new Date(2022, 11, 30),
      maxDate: new Date(),
      columns: [],
      food: '',//显示的食物
      endTime: null,//截止时间戳
      addressArr: [],//侧边栏地址
      address: 0,
      tabActive: 0,
      hospitalMeal: [],//医院订餐
      userMeal: [],//用户订餐
      mealList: [],
      mealId: null,
      status: 0,//状态
      roomId: 0,//科室id
      mealTotal: [],//餐品统计
      addressTotal: [],//地址统计
      hospitalOrderNum: null,
      userOrderNum: null,
      totalOrderNum: null,
      totalAddressNum: null,
      singleAddress: {},
      recordDetail: false,
      signQrcode: "",//签收码
      singleRecord: {},//单条记录
      timer: 0,
      userType: "",
      dischargeInformation: false, //出院信息弹框
      leaveHospitalUsers:[] ,//出院名单
    }
  },
  created() {
    this.formatDate(this.maxDate);
    this.food = this.columns[0];
    this.userType = localStorage.getItem('user_type')
  },
  mounted() {
    this.getMealList();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    //轮询签收成功
    getSignStatus() {
      let data = {
        data: this.date,
        mealId: this.mealId,
        roomId: this.roomId
      }
      this.$post('delivery/getStatus', data).then(result => {
        if (result.status === 200) {
          if (result.data.status === 1) {
            this.showSigning = false;
            this.signSuccess = true;
            this.getDeliveryList();
            clearInterval(this.timer);
          }
        }
      });
    },
    //送出
    sendOut(mealId, roomId) {
      Dialog.confirm({
        message: "确定送出吗？",
        confirmButtonColor: '#126AFC',
        overlayStyle: {'z-index': 999}
      }).then(() => {
        let data = {
          mealId,
          roomId
        }
        this.$post('delivery/sendOut', data).then(result => {
          if (result.status === 200) {
            Toast('送出成功');
            this.getDeliveryList();
          } else {
            Toast(result.msg);
          }
        })
      }).catch(() => {
      })
    },
    //展示单条记录
    showRecordDetail(orderItemId) {
      this.$post('delivery/detail', {orderItemId}).then(res => {
        if (res.status === 200) {
          this.singleRecord = res.data;
          this.recordDetail = true;
        }
      })
    },
    //关闭成功签收
    closeSign() {
      this.showSigning = false;
      clearInterval(this.timer);
    },
    //打开签收码
    openSigning() {
      let data = {
        date: this.date,
        mealId: this.mealId,
        roomId: this.roomId,
        type: this.tabActive
      }
      this.$post('delivery/downloadQrcode', data).then(result => {
        if (result.status == 200) {
          this.showSigning = true;
          this.signQrcode = result.data;
          this.timer = setInterval(() => {
            this.getSignStatus();
          }, 2000)
        }
      });
    },
    //切换餐品统计和地址统计
    checkTab(index) {
      this.tabActive = index;
      this.getDeliveryList();
    },
    //获取配送列表
    getDeliveryList() {
      //date:日期，mealId:时段id，roomId:科室id，type:
      let data = {
        date: this.date,
        mealId: this.mealId,
        roomId: this.roomId,
        type: this.tabActive
      }
      this.$post('delivery/list', data).then(result => {
        this.status = result.data.status;
        this.endTime = result.data.endTime - (+new Date());

        if (this.address < 1) {
          this.hospitalOrderNum = result.data.hospitalOrderNum;
          this.userOrderNum = result.data.systemOrderNum;
          this.totalOrderNum = result.data.total;
          this.totalAddressNum = result.data.addressTotal ? result.data.addressTotal : '0';
        } else {
          this.singleAddress = result.data.orderInfo[0];
        }

        if (this.tabActive === 0) {
          this.mealTotal = result.data.orderInfo[0];
        } else {
          this.addressTotal = result.data.orderInfo;
        }
        this.leaveHospitalUsers = result.data.leaveHospitalUsers;
        if(result.data.leaveHospitalUsers.length > 0 && result.data.status != 4){
          this.dischargeInformation = true;
        }
      });
    },
    //获取侧边栏科室
    getAddressList() {
      let data = {
        date: this.date,
        mealId: this.mealId
      }
      this.$post('delivery/addressList', data).then(result => {
        this.addressArr = result.data.address;
        this.getDeliveryList();
      });
    },
    //获取时段
    getMealList() {
      this.$post('delivery/mealList').then(result => {
        if (result) {
          result.data.map(value => {
            this.columns.push(value.name);
          })
          this.food = this.columns[0];
          this.mealList = result.data;
          this.mealId = this.mealList[0].mealId;

          this.getAddressList();
        }
      });
    },
    //滚动菜单
    scrollMenu() {
      let obj = this.$refs
      for (let key in obj) {
        if (obj[key][0].getBoundingClientRect().top > 0 && obj[key][0].getBoundingClientRect().top < 245) {
          this.address = key.charAt(key.length - 1);
        }
      }
    },
    //切换科室
    checkAddress(address, roomId, flag = true) {
      this.address = address;
      this.roomId = roomId;
      this.getDeliveryList();
      //点击时将对应范围滚入可视区
      // this.$refs['menu' + address][0].scrollIntoView()
    },
    //确认时段
    onConfirmTime(val, index) {
      this.food = val;
      this.mealId = this.mealList[index].mealId;
      this.showTime = false;
      //切换时获取科室
      this.address = 0;
      this.roomId = 0;
      this.getAddressList();
    },
    //取消时段选择
    onCancelTime() {
      this.showTime = false;
    },
    //转换时间
    formatDate(date) {
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      this.date = `${date.getFullYear()}-${month}-${day}`;
    },
    //确认日期
    onConfirm(date) {
      this.formatDate(date);
      this.showDate = false;
      //切换时获取科室
      this.address = 0;
      this.roomId = 0;
      this.getAddressList();
    }
  }
}
</script>

<style scoped lang="less">
.delivery {
  height: 100vh;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  font-size: 14px;

  .top {
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #FAFAFA;

    .choose-date {
      display: flex;
      font-size: 15px;

      .date {

      }

      .time-span {
        margin-left: 20px;

        img {
          width: 10px;
          margin-left: 8px;
        }
      }
    }

    .status {
      display: flex;
      align-items: center;
      color: #126AFC;
      font-size: 15px;

      .running {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      .time {
        color: #126AFC;
        font-size: 15px;
      }
    }
  }

  .list-container {
    background: #FFFFFF;
    display: flex;

    .nav-box {
      width: 90px;
      height: calc(100vh - 100px);
      overflow: hidden;


      .nav::-webkit-scrollbar {
        display: none;
      }

      .nav {
        height: 100%;
        overflow-y: scroll;
        scroll-behavior: smooth;
        background: #F7F7F7;

        nav {
          .nav-item {
            height: 50px;
            padding-left: 15px;
            padding-right: 4px;
            box-sizing: border-box;
            display: flex;
            align-items: center;

            span {
              overflow: hidden;
              line-height: 1.2;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              /*! autoprefixer: off */
              -webkit-box-orient: vertical;
              /* autoprefixer: on */
            }
          }

          .active {
            background: #FFFFFF;
          }

          .active + .nav-item {
            border-radius: 0 15px 0 0;
          }
        }
      }
    }

    .content {
      height: calc(100vh - 100px);
      overflow: hidden;
      flex: 1;
      position: relative;

      .dining {
        height: 100%;
        overflow-y: scroll;
        position: relative;

        .tab {
          height: 50px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          position: sticky;

          .tab-item {
            height: 100%;
            line-height: 50px;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            font-size: 13px;
            color: #999999;
          }

          .tab-active {
            color: #000000;
          }

          .tab-active::after {
            content: "";
            display: block;
            width: 80px;
            height: 2px;
            background: #126AFC;
            position: absolute;
            bottom: 0;
          }
        }

        .statistics-box {
          height: calc(100% - 50px);
          margin-top: 5px;
          padding: 0 15px 25px 10px;
          box-sizing: border-box;
          position: relative;

          .total {
            width: 100%;
            font-size: 13px;
            border: 1px solid #DDDDDD;

            .total-item1 {
              height: 40px;
              line-height: 40px;
              display: grid;
              grid-template-columns: 1fr 1fr 1fr;
              border-bottom: 1px solid #DDDDDD;

              span:nth-child(1) {
                padding-left: 11px;
                box-sizing: border-box;
              }
            }

            .total-item1:first-child {
              background: #DDDDDD;
              font-weight: bold;
            }

            .total-item2 {
              height: 30px;
              line-height: 30px;
              text-align: center;
            }
          }

          .mealType-total {
            .list {
              margin-top: 25px;
              font-size: 13px;

              .list-wrap {
                margin-top: 20px;

                .list-title {
                  text-align: center;
                  font-weight: bold;
                }

                .table {
                  margin-top: 20px;

                  .tTitle {
                    height: 40px;
                    line-height: 40px;
                    font-weight: bold;
                    background: #DDDDDD;
                    display: grid;
                    grid-template-columns: 1fr 1fr;

                    span:nth-child(1) {
                      padding-left: 10px;
                    }

                    span:nth-child(2) {
                      text-align: right;
                      padding-right: 24px;
                    }
                  }

                  .tBody {
                    display: flex;
                    flex-direction: column;

                    .tItem {
                      min-height: 40px;
                      //display: grid;
                      //grid-template-columns: 3fr 1fr;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      padding: 4px 0;
                      box-sizing: border-box;

                      span:nth-child(1) {
                        padding-left: 10px;
                        line-height: 1.2;
                      }

                      span:nth-child(2) {
                        min-width: 40px;
                        text-align: right;
                        padding-right: 24px;
                      }
                    }

                    .tItem:nth-child(even) {
                      background: #F5F5F5;
                    }
                  }
                }
              }

              .list-wrap:first-child {
                margin-top: 0;
              }
            }
          }

          .addressType-total {
            .addressType-item {
              .item-name {
                font-size: 20px;
                text-align: center;
                margin-top: 25px;
              }

              table {
                width: 100%;
                margin-top: 19px;

                tr {
                  height: 40px;
                  line-height: 40px;

                  th, td {
                    text-align: left;
                  }

                  th:nth-child(1), td:nth-child(1) {
                    padding-left: 10px;
                    box-sizing: border-box;
                  }
                }

                thead {
                  tr {
                    background: #DDDDDD;
                  }
                }

                tbody {
                  tr:nth-child(even) {
                    background: #F5F5F5;
                  }
                }
              }

              table:nth-child(3) {
                tr {
                  min-height: 40px;
                  box-sizing: border-box;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;

                  td:nth-child(1), th:nth-child(1) {
                    flex: 1;
                    padding-right: 4px;
                    box-sizing: border-box;
                    line-height: 1.2;
                  }

                  td:nth-child(2), th:nth-child(2) {
                    width: 40px;
                  }
                }
              }
            }
          }

          .noMore {
            margin-top: 20px;
            padding-bottom: 80px;
            font-size: 12px;
            color: #CCCCCC;
            text-align: center;
          }

          .allSend {
            width: 260px;
            height: 50px;
            border-radius: 25px;
            position: fixed;
            bottom: 20px;
            border: none;
            font-size: 15px;
          }
        }
      }

      .division {
        height: 100%;
        padding: 0 15px 0 10px;
        overflow-y: scroll;

        .noMore {
          margin-top: 20px;
          font-size: 12px;
          color: #CCCCCC;
          text-align: center;
          padding-bottom: 90px;
        }

        .division-name {
          margin-top: 20px;
          font-size: 30px;
          font-weight: bold;
        }

        .date {
          color: #999999;
          font-size: 18px;
          margin-top: 16px;
        }

        .grid-container {
          width: 100%;
          font-size: 12px;

          table:first-child {
            margin-top: 24px;
          }

          table {
            width: 100%;
            margin-top: 20px;

            tr {
              height: 40px;
              line-height: 40px;

              th:nth-child(1), td:nth-child(1) {
                //padding-left: 10px;
              }
            }

            thead {
              tr {
                background: #DDDDDD;
              }
            }

            tbody {
              tr:nth-child(even) {
                background: #F5F5F5;
              }
              tr.tr-red{
                td{
                  color: #FF0000 !important;
                }
              }
            }
          }
          .catering {
            overflow: hidden;

            table {
              width: 100%;
              tr {
                min-height: 40px;
                //height: auto;
                box-sizing: border-box;

                td:nth-child(1), td:nth-child(2), td:nth-child(3) {
                  width: 50px;
                  box-sizing: border-box;
                  text-align: left;
                  word-break: break-all;
                  word-wrap: break-word;
                  line-height: 1.2;
                  padding-left: 10px;
                }
              }

              tobody {


                //th:nth-child(4), th:nth-child(5), th:nth-child(6), td:nth-child(4), td:nth-child(5), td:nth-child(6) {
                //  text-align: center;
                //}
              }
            }
          }

          .meal {
            table {
              tr {
                th, td {
                  text-align: left;
                  padding-left: 10px;
                  width: 54px;
                }

                th:nth-child(1), th:nth-child(2), th:nth-child(3), td:nth-child(1), td:nth-child(2), td:nth-child(3) {
                  //width: 40px;
                  word-break: break-all;
                  word-wrap: break-word;
                  line-height: 1.2;
                }

                th:nth-child(4), td:nth-child(4) {
                  display: block;
                  //width: 98px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }
          }

          .catering-total {
            margin-top: 25px;

            .catering-title {
              text-align: center;
              font-size: 13px;
              font-weight: bold;
            }

            table {

              tr {
                th:nth-child(1), td:nth-child(1) {
                  padding-left: 10px;
                }

                th, td {
                  text-align: left;
                }
              }
            }
          }

          .hospitalMeal {
            table {
              tr {
                display: flex;
                justify-content: space-between;
                align-items: center;
                line-height: 1.2;

                td:nth-child(1), th:nth-child(1) {
                  flex: 1;
                  padding-right: 8px;
                  box-sizing: border-box;
                  padding-left: 10px;
                }

                td:nth-child(2), th:nth-child(2) {
                  width: 40px;
                }

                th, td {
                  text-align: left;
                }
              }
            }
          }

          .userMeal {
            table {
              th:nth-child(1), td:nth-child(1) {
                padding-left: 10px;
              }

              tr {
                th, td {
                  text-align: left;
                }
              }
            }
          }
        }

        .btnGroup {
          display: flex;
          flex-direction: column;
          padding: 0 15px 10px 10px;
          box-sizing: border-box;
          position: fixed;
          bottom: 20px;

          button {
            width: 260px;
            height: 50px;
            border-radius: 25px;
            border: none;
            font-size: 15px;
            font-weight: bold;
            margin-top: 7px;
          }

          button:first-child {
            margin-top: 0;
          }
        }
      }

      .dining::-webkit-scrollbar {
        display: none;
      }

      .division::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .signing, .signSuccess {
    .close {
      width: 100%;
      height: 50px;
      border-radius: 25px;
      background: #EEEEEE;
      font-size: 18px;
      color: #999999;
      text-align: center;
      line-height: 50px;
      margin-top: 20px;
    }
  }

  .signing {
    width: 325px;
    padding: 30px 20px 20px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tips {
      font-size: 15px;
      font-weight: bold;
      text-align: center;
    }

    .qrCodeBox {
      width: 250px;
      height: 250px;
      padding: 8px;
      box-sizing: border-box;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .signSuccess {
    width: 325px;
    padding: 0 20px 20px 20px;
    box-sizing: border-box;

    .success {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 80px;

      img {
        width: 285px;
      }
    }
  }

  .recordDetail {
    width: 325px;
    padding: 25px 20px 20px 20px;
    box-sizing: border-box;
    font-size: 15px;

    .title {
      display: flex;
      flex-direction: column;
      align-items: center;

      span:nth-child(1) {
        font-size: 30px;
        font-weight: bold;
      }

      span:nth-child(2) {
        color: #999999;
        margin-top: 9px;
      }
    }

    .content {
      margin-top: 25px;

      .item {
        margin-top: 14px;
      }

      .item:first-child {
        margin-top: 0;
      }

      .meal {
        display: flex;
        align-items: flex-start;
        margin-top: 25px;

        span:nth-child(1) {
          white-space: nowrap;
        }

        span:nth-child(2) {
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
      }

      .remark {
        margin-top: 25px;
        padding-left: 54px;
        line-height: 25px;
      }

      .close {
        margin-top: 30px;

        button {
          width: 100%;
          height: 50px;
          border-radius: 25px;
          border: none;
          font-size: 18px;

        }
      }
    }
  }

  .discharge-information{
    width: 85vw;
    padding: 60px 10px 20px;
    .sub-btn{
      width: 100%;
      height: 45px;
      text-align: center;
      line-height: 45px;
      border-radius: 10px;
      background: #126AFC;
      margin-top: 15px;
      color: #fff;
      font-size: 14px;
    }
    .discharge-list{
      background: #FEF2F2;
      border-radius: 10px;
      overflow: hidden;
      margin-bottom: 30px;
      table{
        width: 100%;
        tr{
          font-weight: 400;
          height: 40px;
          line-height: 40px;
          color: #FF0000;
          font-size: 18px;
          td:nth-child(1) {
            padding-left: 10px;
          }

        }
      }
    }
  }
}
</style>